import { store } from '@/store';
import axios from '@/utils/axios';
import moment from 'moment';

const member={
    /** 更新會員條款版本
     * @param {Array} item - 條款類型
     */
    UpdateMemberTerms(item){
        // 因條款版本目前紀錄後還沒有用處，所以更新失敗也不要跳出訊息干擾流程
        axios.post(apiUrl.UpdateMemberTerms, {
            source: window.location.href,
            terms: _.map(store.getters['terms/getByNoteTypes'](item), o => {
                return {
                    id: o.id,
                    insures: o.insCategory,
                    cid: o.noteType,
                    publishDate: moment(o.date).format('YYYY-MM-DDT00:00:00')
                };
            })
        }, {
            headers: {'Auth': store.state.auth.token}
        }).then(res => {
            // if (res.data.code !== 200) {
            //     store.commit('setDialog', {
            //         active: true,
            //         title: '會員條款版本更新失敗',
            //         text: res.data.message
            //     });
            // }
        }).catch(err => {
            // store.commit('setDialog', {
            //     active: true,
            //     title: '會員條款版本更新失敗',
            //     text: err.response ? err.response.data.message : null
            // });
        });
    }
};

export default member;